export default {
  items: [],
  defaultSort: {
    page: 1,
    column: 'updated_at',
    order: 'descending',
    limit: 25,
  },
  sort: {
    page: 1,
    column: 'updated_at',
    order: 'descending',
    limit: 25,
    filter: '',
  },
  more: true,
  loading: false,
  logs: {
    items: [],
    limit: 50,
    loading: false,
    page: 1,
    total: 0,
  },
  total: 0,
  pendingProgressUpdate: [],
};
